import { Dayjs } from 'dayjs';
import {
  DefaultFetchError,
  FetchCreate, FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate, useFetchDelete,
  useFetchGet,
  useFetchGetId, useFetchUpdate,
} from '../fetch';

export interface Category {
  id: string;
  name: string;
  logo: string;
  description: string;
  removed: boolean;
  articlesSize?: number;
}

export interface SubCategory {
  id: string;
  name: string;
  logo: string;
  description: string;
  removed: boolean;
  articlesSize?: number;
}

export interface CategoryParams {
  productId?: string;
}

interface CategoryFetchOptions {
  autoStart?: boolean;
  params?: CategoryParams;
}

export const useCategoryGet = (
  options?: CategoryFetchOptions,
)
: FetchGet<Category[], CategoryParams, DefaultFetchError> => (
  useFetchGet('categories', { autoStart: options?.autoStart ?? true, authorization: false, params: options?.params })
);

export interface SubCategoryParams {
  categoryId?: string;
}

interface SubCategoryFetchOptions {
  autoStart?: boolean;
  params?: SubCategoryParams;
}

export const useSubCategoryGet = (
  options?: SubCategoryFetchOptions,
): FetchGet<SubCategory[], SubCategoryParams, DefaultFetchError> => (
  useFetchGet('sub-category', {
    autoStart: options?.autoStart ?? true,
    authorization: false,
    params: options?.params,
  })
);
